{"schemaVersion":1,"release":{"version":"1.1.5","build":167,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.5-167.dmg","sha256":"f6291207d1f9c9c1ebfdc3233e52065639a31805002030aebf4229775ca3206c","size":29316421}}
